import { styled } from '@defa/defa-component-library';

const mobileBreakpoint = '768px';

export const Root = styled.div`
    display: grid;
    grid-template-columns: 360px minmax(0, 1fr);
    min-height: 100%;
    background: linear-gradient(
        90deg,
        ${({ theme }) => theme.firstSideBackgroundColor} 0 360px,
        ${({ theme }) => theme.secondSideBackgroundColor} 360px 100%
    );

    @media (max-width: ${mobileBreakpoint}) {
        grid-template-columns: 100vw;
        background: ${({ theme }) => theme.secondSideBackgroundColor};
    }
`;

export const BrandSide = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: ${({ theme }) => theme.spacing(6)} ${({ theme }) => theme.spacing(4)};

    @media (max-width: ${mobileBreakpoint}) {
        display: none;
    }
`;

export const BrandContent = styled.div`
    display: flex;
    width: 100%;
    max-width: 360px;
    min-height: 720px;
    align-items: flex-start;
    justify-content: center;
`;

export const MainSide = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: ${({ theme }) => theme.spacing(6)} ${({ theme }) => theme.spacing(4)};
    min-width: 0;

    @media (max-width: ${mobileBreakpoint}) {
        padding: ${({ theme }) => theme.spacing(3)};
    }
`;

export const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(3)};
    width: 100%;
    max-width: 640px;
    min-width: 0;
    padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(3)};

    h1 {
        margin-top: ${({ theme }) => theme.spacing(8)};
        @media (max-width: ${mobileBreakpoint}) {
            margin-top: 0;
        }
    }
`;

export const MobileHeader = styled.div`
    display: none;
    padding-bottom: ${({ theme }) => theme.spacing(3)};

    @media (max-width: ${mobileBreakpoint}) {
        display: flex;
        align-items: center;
        gap: ${({ theme }) => theme.spacing(2)};
    }
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
    min-width: 0;
    margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const ChipList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing(1)};
`;

export const Chip = styled.span`
    display: inline-flex;
    align-items: center;
    min-height: 32px;
    padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
    border-radius: 999px;
    background-color: ${({ theme }) => theme.background.default};
    color: ${({ theme }) => theme.textColor};
    max-width: 100%;
    word-break: break-word;
`;

export const ActionRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing(2)};

    @media (max-width: ${mobileBreakpoint}) {
        flex-direction: column;

        > * {
            width: 100%;
        }
    }
`;
